/** E.164 without + (India) — same number as tel:9310965215 */
export const WHATSAPP_E164 = "919310965215";

export function whatsappUrl(message) {
  const text =
    message ??
    "Hi, I'm interested in a property consultation.";
  return `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent(text)}`;
}
